import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const ListsToolbarGroup = () => {
  const { editor } = useEditorContext();

  return (
    <>
      <ToolbarItem
        id="ul-toolbar-item"
        tooltip="Számozatlan lista"
        active={editor.isActive("bulletList")}
        onToggle={() => editor.chain().focus().toggleBulletList().run()}
        icon={<i className="fa fa-list-ul" aria-hidden="true" />}
        hotkey="Ctrl + Shift + 8"
      />
      <ToolbarItem
        id="ol-toolbar-item"
        tooltip="Számozott lista"
        active={editor.isActive("orderedList")}
        onToggle={() => editor.chain().focus().toggleOrderedList().run()}
        icon={<i className="fa fa-list-ol" aria-hidden="true" />}
        hotkey="Ctrl + Shift + 7"
      />
    </>
  );
};

export default ListsToolbarGroup;
